<template>
  <div
    class="drilltags_update"
    @keydown.stop.esc="$emit('close')"
    @keydown.stop.enter="$emit('confirm')"
  >
    <div
      class="gw_input_wrapper w-100"
      style="
        --error-message-height-active: 8rem;
        --input-padding: 0 0.25rem;
        --input-border-width: 1px;
        --input-border-radius: 4px;
        --input-height: 2rem;
      "
      :class="{
        gw_input_error: tagName.length > 256 || errorSameNameexists,
      }"
    >
      <input
        ref="inputUpdate"
        :value="tagName"
        type="text"
        class="drilltags_tag_name"
        spellcheck="false"
        @input="e => $emit('update:name', e.target.value)"
      />
      <div class="gw_input_error_message">
        {{
          errorSameNameexists
            ? $t(`messages.same_tag_exists`)
            : $t(`messages.field_name_too_many_characters`, {
                max_chars: 256,
              })
        }}
      </div>
    </div>
    <div class="drilltags_clrs">
      <div
        v-for="hex in colors"
        :key="hex"
        class="drilltags_tag_clrsr_box gw_btn tagdrill"
        :style="`
            --clr-back:${hex};
            --brighten-hover: 0.35;
            --height:auto;
          `"
        @click="$emit('update:color_hex', hex), (canDelete = false)"
      >
        <i
          v-if="color_hex === hex"
          class="mdi mdi-check text-large line-height_1 position-absolute"
        ></i>
      </div>
    </div>
    <div
      class="gw_btn gw_btn_text ml-auto"
      @click="
        ;(canDelete = true),
          $nextTick(() => {
            if (!$refs.deleteBtn) return
            if (!inputAutofocus) return
            $refs.deleteBtn.focus()
          })
      "
    >
      <i class="mdi mdi-trash-can-outline mr-1"></i>
      {{ $t('btn.delete') }}
    </div>
    <div
      v-if="canDelete"
      ref="deleteBtn"
      tabindex="1"
      class="gw_btn"
      data-gwmenu="noclose"
      style="--clr-back: var(--clr-error)"
      @click="$emit('delete')"
      @keydown.enter.stop="$emit('delete')"
    >
      {{ $t('btn.confirm') }}
    </div>

    <div
      v-else
      class="gw_btn gw_btn_primary"
      data-gwmenu="noclose"
      :class="{
        'gw_btn_disabled no-events': tagName.length > 256 || errorSameNameexists,
      }"
      @click="$emit('confirm')"
    >
      {{ $t('btn.confirm') }}
    </div>
  </div>
</template>

<script>
import { getLabelColors } from '@/helpers/constants'
import { nextTick } from 'vue'

export default {
  name: 'TagManager',
  props: {
    tagName: String,
    color_hex: String,
    errorSameNameexists: Boolean,
    inputAutofocus: Boolean,
    colors: { type: Array, default: () => getLabelColors() },
  },
  emits: ['close', 'confirm', 'update:name', 'update:color_hex', 'delete'],
  data() {
    return {
      canDelete: false,
    }
  },
  mounted() {
    nextTick(() => {
      if (!this.$refs.inputUpdate) return
      if (!this.inputAutofocus) return
      this.$refs.inputUpdate.focus()
    })
  },
}
</script>
<style lang="scss" scoped>
.drilltags {
  &_update {
    border-radius: 4px;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.5rem;
    background: var(--clr-black-1-3);
  }
  &_update {
    width: clamp(12rem, 14.5rem, 100vw) !important;
  }
  &_clrs {
    width: 100%;
    display: grid;
    gap: 0.25rem;
    height: 4rem;
    grid-template-columns: repeat(6, 1fr);
    flex-shrink: 0;
    &_box {
      --clr-back: red;
      border-radius: 4px;
      background: var(--clr-back);
      padding: 0;
      height: auto;
    }
  }
}
</style>
